import { adReportOrderStatusOptions, phAppIncOptions } from '../taobao/config'

import doubt from '../../../../assets/home/goodsInfo/doubt.png'

export const adPlatJDOptions = [
	{
		label: '头条',
		value: 400
	},
	{
		label: '快手',
		value: 6
	},
	{
		label: '广点通',
		value: 1
	},
	{
		label: '爱奇艺',
		value: 36
	}
]

export const adReportEventJDOptions = [
	{
		label: '头条-app内下单|in_app_order',
		value: 1
	},
	// {
	// 	label: '头条-app内付费|in_app_pay',
	// 	value: 2
	// },
	// {
	// 	label: '头条-付费|active_pay',
	// 	value: 3
	// },
	{
		label: '头条-商品购买|shopping',
		value: 4
	},
	// {
	// 	label: '头条-支付成功|successful_pay',
	// 	value: 5
	// },
	{
		label: '爱奇艺-下单|206',
		value: 51
	},
	{
		label: '快手-付费|3',
		value: 60
	},
	{
		label: '快手-提交订单|14',
		value: 61
	},
	{
		label: '广点通-下单|COMPLETE_ORDER',
		value: 70
	},
	// {
	// 	label: '广点通-付费|PURCHASE',
	// 	value: 71
	// },
]

export const statusOptions = [
	{
		label: '推广中',
		value: 1
	},
	{
		label: '已关闭',
		value: 2
	}
]

export const renderList = [
	{
		label: '商品id',
		key: 'adGoodsId',
		type: 'input',
		placeholder: '请输入'
	},
	{
		label: '状态',
		key: 'status',
		type: 'select',
		placeholder: '请选择',
		options: statusOptions
	},
	{
		label: '归属客户',
		key: 'customerId',
		type: 'select',
		placeholder: '请选择',
		options: [],
		width: 180
	},
	{
		label: '商品名称',
		key: 'goodsName',
		type: 'input',
		placeholder: '请输入'
	},
]


export const renderMobileList = [
	{
		label: '商品id',
		key: 'adGoodsId',
		type: 'input',
		placeholder: '请输入'
	},
	{
		label: '状态',
		key: 'status',
		type: 'picker',
		placeholder: '请选择',
		valueKey: 'label',
		options: [{ label: '无', value: undefined }, ...statusOptions],
		isRowEnd: true
	},
	{
		label: '归属客户',
		key: 'customerId',
		type: 'picker',
		valueKey: 'label',
		placeholder: '请选择',
		options: [],
	},
	{
		label: '商品名称',
		key: 'goodsName',
		type: 'input',
		placeholder: '请输入',
		isRowEnd: true
	},
]

export const formRenderList = [
	{
		label: '归属客户',
		type: 'select',
		placeholder: '请选择归属客户',
		key: 'customerId',
		options: [],
		require: true
	},
	{
		label: 'skuid',
		type: 'input',
		placeholder: '请输入skuid',
		key: 'adGoodsSkuId',
		maxLength: 50,
		require: true
	},
	{
		label: '商品ID',
		type: 'input',
		placeholder: '请先输入skuid',
		key: 'adGoodsId',
		maxLength: 50,
		require: true,
		disabled: true
	},
	{
		label: '商品标题',
		type: 'input',
		placeholder: '请输入商品标题',
		key: 'goodsName',
		maxLength: 50,
		require: true
	},
	{
		label: '引流平台',
		type: 'select',
		placeholder: '请选择引流平台',
		key: 'adPlatId',
		options: adPlatJDOptions,
		require: true
	},
	{
		label: '推广目标(回传上报时机)',
		type: 'select',
		placeholder: '请选择推广目标',
		key: 'adReportOrderStatus',
		options: adReportOrderStatusOptions,
		require: true,
		tipWidth: 360,
		tipTopText: '有下单和付款两个选项：',
		tipBottomText: '无论选择哪个都和买量平台配置的转化事件(优化目标)无关，这里仅仅只是触发上报的时机，不涉及上报的事件类型报',
		tipIcon: doubt,
		tipList: [
			{
				text: "下单-是在用户提交订单还未付款时回传转化事件，适用于出价低且想快速起量的情况；"
			},
			{
				text: "付款-是在用户提交订单并且完成付款后回传转化事件，适用于出价高想转化效果好的情况。"
			}
		]
	},
	{
		label: '回传转化事件',
		type: 'select',
		placeholder: '请选择回传转化事件',
		key: 'adReportEventId',
		options: adReportEventJDOptions,
		require: true,
		tipIcon: doubt,
		tipList: [{
			text: "详细说明：",
			link: "https://www.yuque.com/docs/share/0cf1790b-0c1c-4afc-9afb-a8e08b4370ec"
		}]
	},
	{
		label: '引流账号数据授权',
		type: 'select',
		placeholder: '请选择',
		key: 'phAppIncId',
		options: phAppIncOptions,
		require: true,
		isHide: true,
		tipWidth: 320,
		tipTopText: '将需要同步数据的账号授权协作者身份给指定邮箱',
		tipBottomText: '注意：如未授权，无法查看账户和计划级的消耗数据，但是不影响查看订单数据和买量转化上报',
		tipIcon: doubt,
		tipList: [
			{
				text: "头条的详细说明：",
				link: "https://www.yuque.com/docs/share/9d800930-0198-4a80-b36d-8f8b2e79c2ea"
			},
			{
				text: "快手的详细说明：",
				link: "https://www.yuque.com/docs/share/81134b12-1adc-4c86-8d4c-6327141c10b9"
			}
		]
		// tipText: '详细说明：',
		// tipLink: 'https://www.yuque.com/docs/share/9d800930-0198-4a80-b36d-8f8b2e79c2ea'
	},
	{
		label: '状态',
		type: 'select',
		placeholder: '请选择状态',
		key: 'status',
		options: statusOptions,
		require: true
	},
	{
		label: '备注',
		type: 'textarea',
		placeholder: '请输入备注',
		key: 'notes',
		maxLength: 100,
		require: true
	},
]

export const formRules = {
	customerId: [
		{ required: true, message: '请选择归属客户', trigger: 'change', type: 'number' }
	],
	adGoodsSkuId: [
		{ required: true, message: '请输入skuid', trigger: 'blur', type: 'string' }
	],
	adGoodsId: [
		{ required: true, message: '请输入商品ID', trigger: 'change' }
	],
	goodsName: [
		{ required: true, message: '请输入商品标题', trigger: 'blur' }
	],
	adPlatId: [
		{ required: true, message: '请选择引流平台', trigger: 'change', type: 'number' }
	],
	adReportOrderStatus: [
		{ required: true, message: '请选择推广目标', trigger: 'change', type: 'number' }
	],
	adReportEventId: [
		{ required: true, message: '请选择回传转化事件', trigger: 'change', type: 'number' }
	],
	phAppIncId: [
		{ required: false, message: '请选择引流台数据同步授权?', trigger: 'change', type: 'number' }
	],
	status: [
		{ required: true, message: '请选择状态', trigger: 'change', type: 'number' }
	],
	notes: [
		{ required: false, message: '请输入备注', trigger: 'blur' }
	]

}



// WEBPACK FOOTER //
// ./src/pages/home/goodsInfo/jd/config.js